export default "__VITE_ASSET__lBAq0L_D__"